var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "wrapper", class: _vm.wrapperClass },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showRefresh,
              expression: "showRefresh"
            }
          ],
          ref: "refreshItem",
          class: {
            refreshItemHorizon: _vm.ifScrollHorizon,
            refreshItemVertical: !_vm.ifScrollHorizon
          }
        },
        [_vm._v("\n        " + _vm._s(_vm.refreshDescription) + "\n    ")]
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLoading,
              expression: "showLoading"
            }
          ],
          ref: "loadingItem",
          class: {
            loadingItemHorizon: _vm.ifScrollHorizon,
            loadingItemVertical: !_vm.ifScrollHorizon
          }
        },
        [_vm._v("\n        " + _vm._s(_vm.loadingDescription) + "\n    ")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }